var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Button, DropdownField, IconButton, InputAdornment, MenuItem, TextField, } from '@one-thd/sui-atomic-components';
import { Search } from '@one-thd/sui-icons';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { requestFormatter, searchByMenuItems, } from '../../../utils/order-history/sort-and-sort-utils';
import { pushPurchaseHistorySearchEvent } from '../../../utils/purchase-history/analytics';
var ClearButton = function (_a) {
    var handleClose = _a.handleClose, isMobile = _a.isMobile, pHRequest = _a.pHRequest, setPHRequest = _a.setPHRequest, setSelectedSearchBy = _a.setSelectedSearchBy, setValue = _a.setValue;
    if (pHRequest.searchBy !== undefined) {
        if (isMobile) {
            return (React.createElement("div", { className: "sui-pt-6" },
                React.createElement(Button, { variant: "secondary", onClick: function () {
                        setValue('searchByTextfield', '');
                        setSelectedSearchBy('itemDescription');
                        setPHRequest(function (prevState) {
                            return __assign(__assign({}, prevState), { searchBy: undefined });
                        });
                        if (handleClose)
                            handleClose();
                    }, fullWidth: true }, "Clear Search")));
        }
        return (React.createElement("button", { type: "button", style: { paddingTop: 25 }, className: "sui-pl-1", onClick: function () {
                setValue('searchByTextfield', '');
                setSelectedSearchBy('itemDescription');
                setPHRequest(function (prevState) {
                    return __assign(__assign({}, prevState), { searchBy: undefined });
                });
            } }, "Clear Search"));
    }
    return null;
};
export var SearchBy = function (_a) {
    var _b, _c, _d, _e, _f;
    var customerType = _a.customerType, handleClose = _a.handleClose, isMobile = _a.isMobile, pHRequest = _a.pHRequest, setPHRequest = _a.setPHRequest;
    var searchByObj = (_b = pHRequest === null || pHRequest === void 0 ? void 0 : pHRequest.searchBy) === null || _b === void 0 ? void 0 : _b[0];
    var searchByKey = ((_d = (_c = Object.entries(searchByObj || {})) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d[0]) || undefined;
    var searchByValue = ((_f = (_e = Object.entries(searchByObj || {})) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f[1]) || '';
    var _g = useState(searchByKey || 'itemDescription'), selectedSearchBy = _g[0], setSelectedSearchBy = _g[1];
    var _h = useForm({
        mode: 'onBlur',
        defaultValues: {
            searchByTextfield: searchByValue,
        },
        shouldUnregister: true,
    }), errors = _h.formState.errors, register = _h.register, watch = _h.watch, setValue = _h.setValue, clearErrors = _h.clearErrors, unregister = _h.unregister;
    var watchSearchByTextfield = watch('searchByTextfield');
    useEffect(function () {
        if (selectedSearchBy === 'paypal') {
            setPHRequest(function (prevState) {
                return __assign(__assign({}, prevState), { searchBy: [{ PayPal: '' }], pageNumber: 1 });
            });
            if (handleClose)
                handleClose();
        }
    }, [selectedSearchBy]);
    var handleChange = function (event) {
        setSelectedSearchBy(event.target.value);
        setValue('searchByTextfield', '');
        clearErrors();
        unregister('searchByTextfield');
    };
    var getPlaceholderValue = function () {
        var _a;
        return (_a = searchByMenuItems(setValue).find(function (item) { return item.value === selectedSearchBy; })) === null || _a === void 0 ? void 0 : _a.placeholder;
    };
    var getRegex = function () {
        var _a;
        var regexValue = (_a = searchByMenuItems(setValue).find(function (item) { return item.value === selectedSearchBy; })) === null || _a === void 0 ? void 0 : _a.options;
        if (regexValue) {
            return regexValue;
        }
        return {};
    };
    var getErrorMessage = function (type) {
        var _a, _b;
        return (_b = (_a = searchByMenuItems(setValue).find(function (item) { return item.value === selectedSearchBy; })) === null || _a === void 0 ? void 0 : _a.errorMessages) === null || _b === void 0 ? void 0 : _b[type];
    };
    var getStatus = function () {
        if (errors.searchByTextfield) {
            return 'error';
        }
        return undefined;
    };
    var handleSumbit = function () {
        if ((watchSearchByTextfield === null || watchSearchByTextfield === void 0 ? void 0 : watchSearchByTextfield.trim()) === '' ||
            watchSearchByTextfield === undefined)
            return;
        var watchValue = selectedSearchBy === 'phoneNumber'
            ? watchSearchByTextfield.replaceAll('-', '')
            : watchSearchByTextfield;
        var value = selectedSearchBy && requestFormatter[selectedSearchBy](watchValue);
        // Analytics event call for search by id and value seleted by user.
        pushPurchaseHistorySearchEvent(watchSearchByTextfield, selectedSearchBy);
        if (selectedSearchBy === 'storeName' &&
            watchValue.toLowerCase() === 'online') {
            setPHRequest(function (prevState) {
                return __assign(__assign({}, prevState), { searchBy: [{ transSrc: 'WEB' }] || [], pageNumber: 1 });
            });
        }
        else {
            setPHRequest(function (prevState) {
                return __assign(__assign({}, prevState), { searchBy: value || [], pageNumber: 1 });
            });
        }
        if (handleClose)
            handleClose();
    };
    var ClearButtonProps = {
        isMobile: isMobile,
        setValue: setValue,
        setSelectedSearchBy: setSelectedSearchBy,
        pHRequest: pHRequest,
        setPHRequest: setPHRequest,
        handleClose: handleClose,
    };
    if (customerType === 'b2b') {
        return (React.createElement("div", { className: "sui-flex sui-flex-col sui-w-full md:sui-flex-row lg:sui-flex-row" },
            React.createElement("div", { className: "sui-w-full md:sui-max-w-[202px] lg:sui-max-w-[202px]" },
                React.createElement(DropdownField, { id: "search-by-dropdown", label: "Search By", value: selectedSearchBy, onChange: handleChange, fullWidth: true }, searchByMenuItems(setValue).map(function (item, menuKey) { return (React.createElement(MenuItem, { key: menuKey, value: item.value }, item.name)); }))),
            selectedSearchBy !== 'paypal' && (React.createElement("div", { className: "sui-w-full md:sui-pt-5 md:sui-max-w-[332px] lg:sui-pt-5 lg:sui-max-w-[332px]" },
                React.createElement(TextField, { id: "search-by-textfield", disabled: selectedSearchBy === undefined, placeholder: getPlaceholderValue(), status: getStatus(), statusMessage: errors.searchByTextfield
                        ? getErrorMessage(errors.searchByTextfield.type)
                        : undefined, onKeyPress: function (event) {
                        if (event.charCode === 13)
                            handleSumbit();
                    }, InputProps: __assign(__assign({}, register('searchByTextfield', getRegex())), { endAdornment: !isMobile && (React.createElement(InputAdornment, { position: "end" },
                            React.createElement(IconButton, { disabled: true, "aria-label": "submit-search-by", icon: Search, onClick: function () { return handleSumbit(); } }))), inputProps: { 'aria-label': 'search-by-textfield' } }), fullWidth: true }))),
            React.createElement(ClearButton, __assign({}, ClearButtonProps)),
            isMobile && (React.createElement("div", { className: "sui-pt-6" },
                React.createElement(Button, { disabled: watchSearchByTextfield === undefined ||
                        (watchSearchByTextfield === null || watchSearchByTextfield === void 0 ? void 0 : watchSearchByTextfield.trim()) === '' ||
                        errors.searchByTextfield !== undefined, onClick: function () { return handleSumbit(); } }, "Accept")))));
    }
    return null;
};
